// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kizuizwbhlttcmgmllst.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtpenVpendiaGx0dGNtZ21sbHN0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQwNzgxMDYsImV4cCI6MjA5OTY1NDEwNn0.oQ65DlHrUMEc0yCSwxfMorWMhxqzgymIBg3asjFqQoM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});